module.exports = "/static/assets/c259e9086e890377322bc3bb01e2fefe.png";